import { Reveal, StaggerGroup, StaggerItem } from "../site/Motion";
import { SectionLabel, Icon } from "../site/Bits";
import { CATEGORIES } from "../../lib/site";

export const Categories = () => (
  <section className="relative overflow-hidden bg-ink py-24 text-white" data-testid="categories-section">
    <div className="mesh-glow pointer-events-none absolute inset-0 opacity-40" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="max-w-2xl">
        <SectionLabel dark>Track anything</SectionLabel>
        <h2 className="mt-5 font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl">
          14+ renewal categories, one dashboard.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-white/60">
          From fleet compliance to personal warranties — if it expires, RenewTracker can track it.
        </p>
      </Reveal>

      <StaggerGroup className="mt-14 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4" stagger={0.05}>
        {CATEGORIES.map((c) => (
          <StaggerItem key={c.name}>
            <div
              data-testid={`category-${c.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="group flex items-center gap-3 rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm transition-[background-color,border-color,transform] duration-300 hover:-translate-y-1 hover:border-greenaccent/40 hover:bg-white/10"
            >
              <span className="grid h-10 w-10 shrink-0 place-items-center rounded-xl bg-white/10 text-greenaccent transition-colors duration-300 group-hover:bg-greenaccent group-hover:text-white">
                <Icon name={c.icon} className="h-5 w-5" />
              </span>
              <span className="text-sm font-medium leading-tight text-white/90">{c.name}</span>
            </div>
          </StaggerItem>
        ))}
      </StaggerGroup>
    </div>
  </section>
);

export default Categories;
